import { ButtonProps } from "@mui/material/Button";
import { ReactNode, MouseEvent, useState } from "react";
import useApplication from "../../hooks/useApplication.hooks";
import Button from "./StandardButton";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SaveIcon from '@mui/icons-material/Save';
interface SaveButtonProps extends ButtonProps {
    children: ReactNode;
    icon: ReactNode;
}

const SaveButton = (props: SaveButtonProps) => {
    const { children, icon, onClick, ...restProps } = props;
    const { isLoading, setIsLoading } = useApplication();
    const [success, setSuccess] = useState(false);

    const handleClick = async (e: MouseEvent<HTMLButtonElement>) => {
        setSuccess(false);

        try {
            if (onClick) {
                await onClick(e);
            }

            setSuccess(true);
        } catch (err) {
            throw err;
        } finally {
            setTimeout(() => {
                setSuccess(true);
                setTimeout(() => setSuccess(false), 2000);
            }, 2000);
        }
    };

    const color = isLoading ? "grey" : "white";

    return (
        <Button icon={success ? <CheckCircleIcon color='success' /> : <SaveIcon />} showLoading={true} onClick={handleClick} {...restProps}>
            {children}
        </Button>
    )
};

export default SaveButton;
